// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  lastWhiffAt: __t.timestamp().name("last_whiff_at"),
  staggeredUntil: __t.timestamp().name("staggered_until"),
  slideStartedAt: __t.timestamp().name("slide_started_at"),
  moveMode: __t.u8().name("move_mode"),
  updatedAt: __t.timestamp().name("updated_at"),
});
